/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Col_ActionInputs */

const cs_ebr_col_action = /** @type {(inputs: Ebr_Col_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akce`)
};

const en_ebr_col_action = /** @type {(inputs: Ebr_Col_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

/**
* | output |
* | --- |
* | "Action" |
*
* @param {Ebr_Col_ActionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_col_action = /** @type {((inputs?: Ebr_Col_ActionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Col_ActionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_col_action(inputs)
	return cs_ebr_col_action(inputs)
});